<template>
    <div class="box box--space-vertical-xl">
        <div class="d-md-none d-sm-block">
            <slot name="horizontalLinks"></slot>
        </div>

        <div class="mm-section">
            <div class="mm-section-content">
                <div class="container-fluid w-100">
                    <div class="row">
                        <div class="col col-md-auto d-none d-md-block">
                            <slot name="links"></slot>
                        </div>
                        <div class="col">
                            <slot v-if="themesRequestState === 'success'"
                                name="themes">
                            </slot>
                            <div
                                v-else-if="themesRequestState === 'request'"
                                class="box box--center box--space-inside">
                                <app-spinner />
                            </div>
                            <div v-else-if="themesRequestState === 'failure'">
                                Error in loading data
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        themesRequestState: {
            type: String
        }
    }
}
</script>